<div class="text-center">
  <img
    src="/assets/images/parrotnotfound.gif"
    alt="Parrot not found"
    height="64px"
    class="m-3"
  />
  <h3>Page not found</h3>
  <p>You appear to have tried to access a page that doesn't exist.</p>
</div>
